import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import { H4 } from "../../../../../AbstractElements";
import { Favorites } from "../../../../../Constants/Constants";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import ViewBookmark from "../../ViewBookmarks";
import FavDataLoop from "./FavDataLoop";

const FavDataTab = () => {
  const { gridView } = useAppSelector((state)=>state.bookmarkTab)
  return (
    <TabPane tabId="2">
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <H4 className="mb-0">{Favorites}</H4>
          <ViewBookmark />
        </CardHeader>
        <CardBody>
          <div className={`details-bookmark text-center ${gridView ? "" : "list-bookmark"}`}>
            <FavDataLoop />
          </div>
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default FavDataTab;
